import React from 'react';
import { observer } from 'mobx-react-lite';
import { fg } from '@atlaskit/platform-feature-flags';
import { debounce } from '../../../jira-common/utils/CommonUtils';
import { FormQuestionType } from '../../models/Form';
import { toUserPickerQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditUserPicker } from './edit/EditUserPicker';
import { ViewUserPicker } from './view/ViewUserPicker';
export var UserPicker = observer(function (_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    questionStore = _ref.questionStore,
    formStore = _ref.formStore,
    displayMode = _ref.displayMode;
  var isMulti = questionStore.formQuestion.type === FormQuestionType.UserMultiple;
  var value = questionStore.currentAnswer ? toUserPickerQuestionAnswerOrEmpty(questionStore.currentAnswer).map(function (item) {
    return {
      value: item.id,
      label: item.name
    };
  }) : null;
  var showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu, _questionStore$formQu2;
    var loadOptions = debounce(function (inputValue, callback) {
      var input = inputValue.trim();
      if (input) {
        var _questionStore$issueF;
        formStore.searchUsersWithFieldConfig(questionStore.formQuestion.jiraField, (_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.fieldConfigId, input).then(function (results) {
          callback(results);
        }).catch(function (error) {
          callback([]);
        });
      } else {
        callback([]);
      }
    }, fg('proforma_reduce_debounce_for_csm') ? 250 : 500);
    var onChange = function onChange(newValue) {
      var values;
      if (!newValue) {
        values = [];
      } else if (isMulti) {
        values = newValue.map(function (item) {
          return {
            id: item.value,
            name: item.label
          };
        });
      } else {
        values = [{
          id: newValue.value,
          name: newValue.label
        }];
      }
      questionStore.setAnswer(values);
    };
    return /*#__PURE__*/React.createElement(EditUserPicker, {
      id: id,
      errorId: errorId,
      isMulti: isMulti,
      value: value,
      loadOptions: loadOptions,
      onChange: onChange,
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      label: (_questionStore$formQu2 = questionStore.formQuestion) === null || _questionStore$formQu2 === void 0 ? void 0 : _questionStore$formQu2.label
    });
  }
  return /*#__PURE__*/React.createElement(ViewUserPicker, {
    id: id,
    isMulti: isMulti,
    value: value,
    displayMode: displayMode
  });
});